"use strict";
var Ajaxinate = function (t) {
    var e = t || {};
    this.settings = Object.assign({
        pagination: "#pagination-wrapper",
        method: "scroll",
        container: "#product-grid",
        // ПРАВКА 1: триггер срабатывает за ~2.5 экрана до пагинации
        offset: Math.round(window.innerHeight * 2.5),
        loadingText: "טוען...",
        async: true,
        callback: null
    }, e),
    this.addScrollListeners = this.addScrollListeners.bind(this),
    this.addClickListener = this.addClickListener.bind(this),
    this.onPaginationVisible = this.onPaginationVisible.bind(this),
    this.stopMultipleClicks = this.stopMultipleClicks.bind(this),
    this.destroy = this.destroy.bind(this),
    this.containerElement = document.querySelector(this.settings.container),
    this.paginationElement = document.querySelector(this.settings.pagination),
    this.isLoading = false,
    this.cache = null, // ПРАВКА 2: кэш префетча { url, promise }
    this.initialize()
};

Ajaxinate.prototype.initialize = function () {
    this.containerElement && {
        click: this.addClickListener,
        scroll: this.addScrollListeners
    }[this.settings.method]()
};

// ПРАВКА 3: IntersectionObserver вместо scroll/resize-листенеров.
// rootMargin = offset — «зона видимости» расширена вниз на offset px,
// поэтому загрузка стартует задолго до того, как пагинация попадёт на экран.
Ajaxinate.prototype.addScrollListeners = function () {
    if (!this.paginationElement) return;
    this.observer = new IntersectionObserver(this.onPaginationVisible, {
        rootMargin: this.settings.offset + "px 0px"
    });
    this.observer.observe(this.paginationElement);
};

Ajaxinate.prototype.onPaginationVisible = function (entries) {
    if (!entries.some(function (e) { return e.isIntersecting; })) return;
    this.nextPageLinkElement = this.paginationElement.querySelector("a");
    this.removeScrollListener();
    if (this.nextPageLinkElement) {
        this.nextPageLinkElement.innerHTML = this.settings.loadingText;
        this.nextPageUrl = this.nextPageLinkElement.href;
        this.loadMore();
    }
};

Ajaxinate.prototype.addClickListener = function () {
    this.paginationElement && (this.nextPageLinkElement = this.paginationElement.querySelector("a"),
    this.clickActive = !0,
    null !== this.nextPageLinkElement && this.nextPageLinkElement.addEventListener("click", this.stopMultipleClicks))
};

Ajaxinate.prototype.stopMultipleClicks = function (t) {
    t.preventDefault(),
    this.clickActive && (this.nextPageLinkElement.innerHTML = this.settings.loadingText,
    this.nextPageUrl = this.nextPageLinkElement.href,
    this.clickActive = !1,
    this.loadMore())
};

// ПРАВКА 2: загрузка страницы через кэш.
// Если страница уже префетчится/префетчена — возвращаем тот же promise.
Ajaxinate.prototype.fetchPage = function (url) {
    if (this.cache && this.cache.url === url) return this.cache.promise;
    this.cache = {
        url: url,
        promise: fetch(url).then(function (r) {
            if (!r.ok) throw new Error("Network response was not ok");
            return r.text();
        })
    };
    // при ошибке сбрасываем кэш, чтобы можно было повторить запрос
    this.cache.promise.catch(function () { this.cache = null; }.bind(this));
    return this.cache.promise;
};

Ajaxinate.prototype.loadMore = async function () {
    if (this.isLoading || !this.nextPageUrl) return; // блокировка дублей
    if (this.containerElement.children.length == 0) return;
    this.isLoading = true;
    try {
        // если страница была префетчена — вставка мгновенная
        const html = await this.fetchPage(this.nextPageUrl);

        const doc = new DOMParser().parseFromString(html, "text/html");
        const containerContent = doc.querySelector(this.settings.container);
        const paginationContent = doc.querySelector(this.settings.pagination);

        this.containerElement.insertAdjacentHTML("beforeend", containerContent.innerHTML);

        if (window.initJsSlideProduct) {
            window.initJsSlideProduct();
        }

        if (!paginationContent) {
            document.querySelector("#pagination-wrapper").style.display = "none";
            window.blockLoadMore = true;
        } else {
            document.querySelector("#pagination-wrapper").style.display = "block";
            this.paginationElement.innerHTML = paginationContent.innerHTML;

            // ПРАВКА 2: сразу греем кэш следующей страницей —
            // она качается, пока пользователь смотрит только что вставленные товары
            const nextLink = this.paginationElement.querySelector("a");
            if (nextLink) this.fetchPage(nextLink.href);

            if (this.settings.callback && typeof this.settings.callback === "function") {
                this.settings.callback(doc);
            }

            this.initialize();
        }
    } catch (error) {
        console.error("Ошибка при загрузке:", error);
    } finally {
        this.isLoading = false; // освобождаем в конце
    }
};

Ajaxinate.prototype.removeClickListener = function () {
    if (this.nextPageLinkElement) {
        this.nextPageLinkElement.removeEventListener("click", this.stopMultipleClicks);
    }
};

Ajaxinate.prototype.removeScrollListener = function () {
    if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
    }
};

Ajaxinate.prototype.destroy = function () {
    const deregister = {
        click: this.removeClickListener.bind(this),
        scroll: this.removeScrollListener.bind(this)
    }[this.settings.method];

    if (deregister) deregister();

    this.nextPageUrl = null;
    this.cache = null; // сбрасываем префетч (после фильтрации страницы другие)
    return this;
};

// Функция инициализации наблюдателя
function initAjaxinateObserver() {
    const targetNode = document.querySelector(".product-grid-container");

    if (!targetNode) {
        console.error("Контейнер .product-grid-container не найден");
        return;
    }

    // Создаем функцию для (пере)запуска Ajaxinate
    const restartAjaxinate = () => {
        if (window.blockLoadMore) {
            window.blockLoadMore = false;
            return false;
        }

        // 1. Если экземпляр уже существует — полностью его уничтожаем
        if (window.ajaxinateInstance) {
            window.ajaxinateInstance.destroy();
        }

        // 2. Проверяем, есть ли пагинация в DOM
        const pagination = document.querySelector("#pagination-wrapper");
        if (pagination) {
            // Принудительно показываем пагинацию (если она была скрыта на других фильтрах)
            pagination.style.display = "block";

            // 3. Создаем новый экземпляр
            window.ajaxinateInstance = new Ajaxinate({
                container: "#product-grid",
                pagination: ".infinite_next",
                // ПРАВКА 1: загрузка стартует за 2.5 экрана до конца списка
                offset: Math.round(window.innerHeight * 2.5)
            });

            if (window.initProductCardSliders) {
                window.initProductCardSliders();
            }
        }
    };

    // Настраиваем обсервер
    const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
            // Если в контейнере изменились дочерние элементы (фильтр обновил список)
            if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
                restartAjaxinate();
                break;
            }
        }
    });

    // Начинаем слежку за контейнером
    observer.observe(targetNode, { childList: true });

    // Первый запуск при загрузке страницы
    restartAjaxinate();
}

document.addEventListener("DOMContentLoaded", initAjaxinateObserver);